"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _localization = require("@lt/localization");

var _CurrencyFormat = _interopRequireDefault(require("../CurrencyFormat"));

var _instantConfirm = _interopRequireDefault(require("../../icons/userflow/css-svg-icons/instant-confirm"));

var _userflow = require("../../icons-react/userflow");

var _PriceWithoutCashback = require("../HotelCard/components/PriceWithoutCashback");

var HotelCardPrice = function HotelCardPrice(_ref) {
  var price = _ref.price,
      currencyCode = _ref.currencyCode,
      cheapType = _ref.cheapType,
      oldPrice = _ref.oldPrice,
      priceWithCashback = _ref.priceWithCashback,
      instantConfirm = _ref.instantConfirm,
      href = _ref.href,
      className = _ref.className,
      dataLayer = _ref.dataLayer,
      isSmallCard = _ref.isSmallCard,
      isMapCard = _ref.isMapCard;

  var _useTranslation = (0, _localization.useTranslation)(),
      t = _useTranslation.t;

  var isPremium = cheapType === 'diamond';
  var mainPrice = priceWithCashback || price;
  var priceWithoutCashback = priceWithCashback ? price : null;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(StyledHotelCardPrice, {
    className: className,
    isSmallCard: isSmallCard
  }, instantConfirm && /*#__PURE__*/_react["default"].createElement(StyledInstantConfirmIcon, null), /*#__PURE__*/_react["default"].createElement(StyledPriceLink, {
    as: isMapCard ? 'span' : 'a',
    target: "_blank",
    rel: "noopener",
    href: href,
    onClick: function onClick(e) {
      var _dataLayer$hotelClick;

      dataLayer === null || dataLayer === void 0 ? void 0 : (_dataLayer$hotelClick = dataLayer.hotelClicked) === null || _dataLayer$hotelClick === void 0 ? void 0 : _dataLayer$hotelClick.call(dataLayer);
    }
  }, /*#__PURE__*/_react["default"].createElement(StyledPrice, {
    value: mainPrice,
    currencyCode: currencyCode,
    itemProp: "priceRange",
    prefix: isMapCard ? "".concat(t('hotel.menuPrice.valuePrice')) : '',
    $isMapCard: isMapCard
  })), /*#__PURE__*/_react["default"].createElement(StyledPriceVariationsWrapper, {
    isSmallCard: isSmallCard,
    priceWithoutCashback: priceWithoutCashback
  }, isSmallCard && priceWithoutCashback && /*#__PURE__*/_react["default"].createElement(_PriceWithoutCashback.PriceWithoutCashback, {
    count: priceWithoutCashback,
    currencyCode: currencyCode
  }), oldPrice ? /*#__PURE__*/_react["default"].createElement(StyledOldPriceContainer, {
    className: className,
    isSmallCard: isSmallCard,
    priceWithoutCashback: priceWithoutCashback
  }, isPremium ? /*#__PURE__*/_react["default"].createElement(StyledDiamondCircleIconWrapper, null, /*#__PURE__*/_react["default"].createElement(StyledDiamondCircleIcon, null)) : /*#__PURE__*/_react["default"].createElement(StyledHotPriceIconWrapper, null, /*#__PURE__*/_react["default"].createElement(StyledHotPriceIcon, null)), /*#__PURE__*/_react["default"].createElement(StyledOldPrice, {
    value: oldPrice,
    currencyCode: currencyCode,
    isPremium: isPremium
  })) : null)), !isSmallCard && priceWithoutCashback && /*#__PURE__*/_react["default"].createElement(_PriceWithoutCashback.PriceWithoutCashback, {
    count: priceWithoutCashback,
    currencyCode: currencyCode
  }));
};

var StyledBaseIconWrapper = _styledComponents["default"].div.withConfig({
  displayName: "HotelCardPrice__StyledBaseIconWrapper",
  componentId: "sc-4mork-0"
})(["position:relative;height:16px;"]);

var StyledDiamondCircleIconWrapper = (0, _styledComponents["default"])(StyledBaseIconWrapper).withConfig({
  displayName: "HotelCardPrice__StyledDiamondCircleIconWrapper",
  componentId: "sc-4mork-1"
})(["top:2px;"]);
var StyledHotPriceIconWrapper = (0, _styledComponents["default"])(StyledBaseIconWrapper).withConfig({
  displayName: "HotelCardPrice__StyledHotPriceIconWrapper",
  componentId: "sc-4mork-2"
})(["top:1px;"]);
var StyledDiamondCircleIcon = (0, _styledComponents["default"])(_userflow.DiamondPriceCircle).withConfig({
  displayName: "HotelCardPrice__StyledDiamondCircleIcon",
  componentId: "sc-4mork-3"
})(["height:13px;"]);

var StyledPriceLink = _styledComponents["default"].a.withConfig({
  displayName: "HotelCardPrice__StyledPriceLink",
  componentId: "sc-4mork-4"
})(["text-decoration:none;flex-shrink:0;margin-right:9px;"]);

var StyledPrice = (0, _styledComponents["default"])(_CurrencyFormat["default"]).withConfig({
  displayName: "HotelCardPrice__StyledPrice",
  componentId: "sc-4mork-5"
})(["", ";font-size:", "px;line-height:1;color:", ";&:hover{color:", ";}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.typography.headline2;
}, function (_ref3) {
  var $isMapCard = _ref3.$isMapCard;
  return $isMapCard ? 24 : 28;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.blackBase;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.blue;
});

var StyledInstantConfirmIcon = _styledComponents["default"].div.withConfig({
  displayName: "HotelCardPrice__StyledInstantConfirmIcon",
  componentId: "sc-4mork-6"
})(["background-image:", ";background-repeat:no-repeat;width:12px;height:24px;margin-right:4px;flex-shrink:0;"], _instantConfirm["default"]);

var StyledOldPrice = (0, _styledComponents["default"])(_CurrencyFormat["default"]).withConfig({
  displayName: "HotelCardPrice__StyledOldPrice",
  componentId: "sc-4mork-7"
})(["text-decoration:line-through;font-size:14px;line-height:16px;margin-left:6px;color:", ";"], function (_ref6) {
  var theme = _ref6.theme,
      isPremium = _ref6.isPremium;
  return isPremium ? theme.colors.blackLight : theme.colors.monza;
});

var StyledPriceVariationsWrapper = _styledComponents["default"].div.withConfig({
  displayName: "HotelCardPrice__StyledPriceVariationsWrapper",
  componentId: "sc-4mork-8"
})(["position:relative;display:flex;overflow:hidden;", " ", " ", ""], function (_ref7) {
  var isSmallCard = _ref7.isSmallCard;
  return isSmallCard ? 'width: 100%; margin-top: 4px;' : '';
}, function (_ref8) {
  var priceWithoutCashback = _ref8.priceWithoutCashback,
      isSmallCard = _ref8.isSmallCard;
  return priceWithoutCashback && isSmallCard ? 'margin-top: 6px;' : '';
}, function (_ref9) {
  var isSmallCard = _ref9.isSmallCard;
  return isSmallCard ? "\n    :after {\n      content: '';\n      position: absolute;\n      right: 0;\n      width: 50px;\n      height: 100%;\n      background-image: linear-gradient(90deg, rgba(255, 255, 255, 0), #fff);\n    };\n  " : '';
});

var StyledOldPriceContainer = _styledComponents["default"].span.withConfig({
  displayName: "HotelCardPrice__StyledOldPriceContainer",
  componentId: "sc-4mork-9"
})(["display:flex;align-items:center;white-space:nowrap;", ""], function (_ref10) {
  var isSmallCard = _ref10.isSmallCard,
      priceWithoutCashback = _ref10.priceWithoutCashback;
  return isSmallCard && priceWithoutCashback ? 'margin-left: 10px;' : '';
});

var StyledHotelCardPrice = _styledComponents["default"].div.withConfig({
  displayName: "HotelCardPrice__StyledHotelCardPrice",
  componentId: "sc-4mork-10"
})(["display:flex;align-items:center;", ""], function (_ref11) {
  var isSmallCard = _ref11.isSmallCard;
  return isSmallCard ? 'flex-wrap: wrap;' : 'margin-bottom: 6px';
});

var StyledHotPriceIcon = (0, _styledComponents["default"])(_userflow.HotPriceCircle).withConfig({
  displayName: "HotelCardPrice__StyledHotPriceIcon",
  componentId: "sc-4mork-11"
})(["height:15px;"]);
HotelCardPrice.displayName = 'HotelCardPrice';

var _default = /*#__PURE__*/_react["default"].memo(HotelCardPrice);

exports["default"] = _default;